module.exports = __webpack_public_path__ + "static/media/15.e7fe3443.jpg";